'use client';

// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { Trans } from '@lingui/macro';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { EChartsOption } from 'echarts';
// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import charts, all with Chart suffix
import { PieChart } from 'echarts/charts';
// import components, all suffixed with Component
import { GridComponent, LegendComponent, PolarComponent, ToolboxComponent, TooltipComponent } from 'echarts/components';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {
//   CanvasRenderer,
SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo } from 'react';
type Props = {
  data?: {
    value: number;
    name: string;
  }[];
};

// Register the required components
echarts.use([TooltipComponent, ToolboxComponent, GridComponent, LegendComponent, PolarComponent, PieChart, SVGRenderer]);
export const TopSix: FC<Props> = (props: Props) => {
  const {
    data = []
  } = props;
  const theme = useTheme();
  const option: EChartsOption = useMemo(() => ({
    legend: {
      show: false,
      top: 'bottom'
    },
    toolbox: {
      show: false,
      feature: {
        mark: {
          show: true
        },
        dataView: {
          show: true,
          readOnly: false
        },
        restore: {
          show: true
        },
        saveAsImage: {
          show: true
        }
      }
    },
    series: [{
      name: 'Nightingale Chart',
      type: 'pie',
      radius: [50, 240],
      center: ['50%', '50%'],
      roseType: 'area',
      itemStyle: {
        borderRadius: 8,
        color: theme.palette.primary.main
      },
      data: data.map((d, idx) => {
        return {
          ...d,
          itemStyle: {
            opacity: 1 - idx / data.length
          },
          label: {
            opacity: 1
          }
        };
      })
    }]
  }), [data, theme]);
  const noData = useMemo(() => data.length === 0, [data]);
  return <Stack component="section" position="relative" width="100%" height="500px" data-sentry-element="Stack" data-sentry-component="TopSix" data-sentry-source-file="index.tsx">
      <ReactEChartsCore echarts={echarts} option={option} notMerge={true} lazyUpdate={true} theme={'theme_name'} style={{
      height: '100%',
      width: '100%'
      // top: 0,
      // left: 0,
      // right: 0,
      // bottom: 0,
      // position: 'absolute',
    }} opts={{
      renderer: 'svg'
    }} data-sentry-element="ReactEChartsCore" data-sentry-source-file="index.tsx" />
      {noData && <Box component="div" position="absolute" top={0} left={0} right={0} bottom={0}>
          <Stack alignItems="center" justifyContent="center" width="100%" height="100%">
            <Paper>
              <Stack spacing={2} alignItems="center" padding={2}>
                <Typography variant="h2">
                  <Trans>Données indisponibles</Trans>
                </Typography>
              </Stack>
            </Paper>
          </Stack>
        </Box>}
    </Stack>;
};